export default __webpack_public_path__ + "static/media/ai-service-provider.11552882.png";